module.exports = __webpack_public_path__ + "static/media/symfonia.b7ec696c.svg";